import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I’m a full-stack developer who fell head over heels for code — and I've been building, breaking, and fixing things ever since. 👨‍💻
              <br />
              <br />I am fluent in classics like
              <i>
                <b className="purple"> Java, JavaScript, both frontend and backened — from React and Next.js on the client side, to Node.js, Sequelize, and databases like MySQL and PostgreSQL on the server side. </b>
              </i>
              <br />
              <br />
              My passion lies in crafting scalable &nbsp;
              <i>
                <b className="purple">Web Applications , Digital Products </b> and
                also I enjoy diving deep into {" "}
                <b className="purple">
                  Cloud Infrastructure
                </b> {" "} with AWS — think {" "}
                <b className="purple">
                  EC2, Lambda, RDS, CloudFormation, CloudFront, Amplify, and CloudWatch. ☁️⚙️
                </b>


              </i>
              <br />
              <br />
              Whenever I get the chance, I love turning ideas into interactive, real-world solutions using the power of 
               <b className="purple">Modern Web Technologies , AI, JavaScript Frameworks , MySQL , </b> and
              <i>
                <b className="purple">
                  {" "}
                  Aws Services.
                </b>
              </i>
              
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Shubhanshu9696"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/shubhanshusst10"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/shubhanshu-tiwari-4a1025215/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/shubhanshu_tiwari__/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
